export default function Footer() {
  return (
    <footer className="bg-[#2d5016] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          <div className="sm:col-span-2 lg:col-span-2">
            <img
              src={`${__BASE_PATH__}logo.webp?ver=${__READDY_VERSION_ID__}`}
              alt="Rancho da Verdura"
              className="h-12 sm:h-16 w-auto mb-4 sm:mb-6"
            />
            <p className="text-white/80 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              Da horta para a sua mesa, com amor e frescor! Produtos selecionados com qualidade premium para você e sua família.
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="https://www.facebook.com/ranchodaverdura/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#9bc53d] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/ranchodaverdura/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#9bc53d] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a
                href="https://wa.me/5519993773158"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#9bc53d] transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Links Rápidos</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#9bc53d] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  Início
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#9bc53d] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#9bc53d] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  Produtos
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('reviews')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#9bc53d] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  Nossos Clientes
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#9bc53d] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Contato</h3>
            <ul className="space-y-2 sm:space-y-3 text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#9bc53d] mt-1 text-sm sm:text-base"></i>
                <span className="text-xs sm:text-sm">Av. João Aranha, 621<br />Paulínia - SP</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#9bc53d] mt-1 text-sm sm:text-base"></i>
                <span className="text-xs sm:text-sm">R. Prof. Zeferino Vaz, 68<br />Paulínia - SP</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-[#9bc53d] text-sm sm:text-base"></i>
                <span className="text-xs sm:text-sm">Seg-Sáb: 7h-21h</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-xs sm:text-sm text-center sm:text-left">
              © 2026 Rancho da Verdura. Todos os direitos reservados.
            </p>
            <p className="text-white/60 text-xs sm:text-sm text-center sm:text-right">
              Criado por{' '}
              <a
                href="https://guepardosites.link"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9bc53d] hover:text-white transition-colors cursor-pointer"
              >
                guepardosites.link
              </a>
            </p>
          </div>
        </div>
      </div>

      <a
        href="https://wa.me/5519993773158"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 w-12 h-12 sm:w-14 sm:h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 z-50 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
      </a>
    </footer>
  );
}
